import {TWSingleResponse} from "./response.models";

export class SensorSpec {
  customerBk: string;
  systemBk: string;
  sensorBk: string;
  componentBk: string;
  levelBk: string;
  levelName: string;
  sensorTypeBk: string;
  sensorSubtype: string;
  valueType: string;
  computationType: string;
  aggregationType: string;
  aggregationLevel: string;
  transformationFactor: number;
  transformationOffset: number;
  multivalueType: string;
  multivalueSensorBk: string;
  bytePosition: number;
  sensorTid: string;
  unit: string;
  readonly name?: string;

  constructor(sensor: any = {}) {
    this.customerBk = sensor.customerBk;
    this.systemBk = sensor.systemBk;
    this.sensorBk = sensor.sensorBk;
    this.componentBk = sensor.componentBk;
    this.levelBk = sensor.levelBk;
    this.levelName = sensor.levelName;
    this.sensorTypeBk = sensor.sensorTypeBk;
    this.sensorSubtype = sensor.sensorSubtype;
    this.valueType = sensor.valueType;
    this.computationType = sensor.computationType;
    this.aggregationType = sensor.aggregationType;
    this.aggregationLevel = sensor.aggregationLevel;
    this.transformationFactor = sensor.transformationFactor;
    this.transformationOffset = sensor.transformationOffset;
    this.multivalueType = sensor.multivalueType;
    this.multivalueSensorBk = sensor.multivalueSensorBk;
    this.bytePosition = sensor.bytePosition;
    this.sensorTid = sensor.sensorTid;
    this.unit = sensor.unit;
    this.name = this.getSensorName();
  }

  private getSensorName() {
    const isNotNone = (v: any) => v && v !== 'none';
    const isAggregated = isNotNone(this.aggregationType) && isNotNone(this.aggregationLevel);

    return [
      this.levelName,
      isAggregated ? this.aggregationLevel : null,
      this.sensorTypeBk,
      isAggregated ? this.aggregationType : null,
    ]
      .filter((v) => !!v)
      .map((v) => v.replace(/_/g, ' '))
      .join(' ');
  }
}

export class SensorType {
  sensorTypeBk: string;
  unit: string;
}

export interface SensorSpecResponse {
  sensor_bk: string;
  level_bk: string;
  sensor_type: string;
  sensor_subtype: string;
  aggregation_type: string;
  aggregation_level: string;
  computation_type: string;
  value_type: string;
  unit: string;
  name: string;
  standard_sensor_bk: string | null;
}

export type SensorSpecDataResponse = TWSingleResponse<{ items: SensorSpecResponse[] }>;
